import apiClient from '../apiClient';

const BASE_URL = '/reportes/referencias';

function buildParams(filtros = {}) {
    const params = {};
    if (filtros.fechaDesde) params.fechaDesde = filtros.fechaDesde;
    if (filtros.fechaHasta) params.fechaHasta = filtros.fechaHasta;
    return params;
}

export async function getResumen(filtros = {}) {
    const { data } = await apiClient.get(`${BASE_URL}/resumen`, { params: buildParams(filtros) });
    return data;
}

export async function getDetalle(filtros = {}) {
    const { data } = await apiClient.get(`${BASE_URL}/detalle`, { params: buildParams(filtros) });
    return data;
}

export async function getAllReportes(filtros = {}) {
    const [resumen, detalle] = await Promise.all([getResumen(filtros), getDetalle(filtros)]);
    return { resumen, detalle };
}
